import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';

import { OptionSetsApiService } from './../optionset-api.service'
import { IOptionSets } from '@ebb-v2/ebb-integration';

import { Apollo} from 'apollo-angular';
import { ListOptionSetsQuery} from '@ebb-v2/ebb-integration';

@Injectable({
    providedIn: 'root'
  })
export class OptionSetsGqlService implements OptionSetsApiService {

  constructor(
    private apollo: Apollo
  ) { }

  public getList(entityName: string): Observable<IOptionSets[]> {
    console.log(`OptionSetsGql.getList()`);
    return this.apollo
      .watchQuery({
        query: ListOptionSetsQuery,
        variables: {
            name: entityName,
        }
      })
      .valueChanges
      .pipe(map(result => result.data['optionSets'] as IOptionSets[]), take(1));
  }

}
